var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedDairyV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_92274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 16.0781C13.186 16.0781 13.4872 15.7769 13.4872 15.4034V10.8373C13.4872 8.88549 13.0053 6.96987 12.0896 5.24702C12.2161 5.19882 12.3306 5.11449 12.4089 5.00003C12.4872 4.88558 12.5294 4.75305 12.5294 4.6145V4.12053C12.5294 3.93982 12.4571 3.77114 12.3306 3.64464C12.2041 3.51814 12.0354 3.44585 11.8547 3.44585H9.58969C9.40897 3.44585 9.2403 3.51814 9.1138 3.64464C8.98729 3.77114 8.91501 3.93982 8.91501 4.12053V4.6145C8.91501 4.75305 8.95717 4.88558 9.03549 5.00003C9.1138 5.11449 9.22223 5.19882 9.35476 5.24702C8.43309 6.96987 7.95117 8.89151 7.95117 10.8433V15.4034C7.95117 15.6926 8.11382 16.0781 8.63188 16.0781H12.8125Z",
    stroke: "#0071E1",
    strokeWidth: 0.903595,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52344 7.68666C8.74632 7.71678 8.8668 7.80714 9.02343 7.90954C9.23427 8.05412 9.47522 8.22279 9.93305 8.22279C10.3909 8.22279 10.6318 8.05412 10.8427 7.90954C11.0294 7.77702 11.18 7.67461 11.5053 7.67461C11.8306 7.67461 11.9752 7.77702 12.1619 7.90954C12.3426 8.03605 12.5535 8.18062 12.9029 8.21676",
    stroke: "#0071E1",
    strokeWidth: 0.903595,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30054 15.8131L8.02344 9.54818L8.668 7.95183H12.9089L13.4811 10.8433L13.3426 15.8131H10.939H8.30054Z",
    fill: "#0071E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_92274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.43359,
    height: 13.5298,
    fill: "white",
    transform: "translate(7.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedDairyV2);
export default __webpack_public_path__ + "static/media/rounded-dairy-v2.0fe19353d276d7a5a3ee71fed49e9b28.svg";
export { ForwardRef as ReactComponent };